//libs
import { useContext, useMemo } from 'react';

//components
import ArrowDownYel from '../images/arrow-down-yel.svg';
import { StoresContext } from '../../../../App';
import { compareStrings } from '../../../../util/compareStrings';

//types
import { ICountriesListProps } from '../types/ICountriesListProps';

export default function CountriesList({
    setCountry
}: ICountriesListProps){
    const { allStores, stores, locationFilters } =
        useContext(StoresContext);

    const countries = useMemo(() => {
        const countries = new Set<string>();
        
        for (const s of allStores) {
            if (s.country) {
                countries.add(s.country);
            }
        }
        return  Array
                    .from(countries)
                    .sort(compareStrings)
                    .sort((itemA, itemB) => 
                        itemA.toLowerCase() === "россия" ? -1 : itemB.toLowerCase() === "россия" ? 1 : 0);

    }, [allStores]);

    const storesCounters = useMemo(() => {
        const counters = new Map<string, number>()

        for (const s of stores) {
            if (s.country) {
                let countryCounter = counters.get(s.country);

                if(countryCounter === undefined) {
                    countryCounter = 0;
                }

                countryCounter++;
                counters.set(s.country, countryCounter);
            }
        }

        return counters;
    }, [stores]);

    return (
        <div className="feature-filter-block country-filter-block">
            <ul className="country-filter-block__list country-filter-block-list">
                {countries.map((item) => {
                    const countryCount = Number(storesCounters.get(item) ?? 0);

                    return ( locationFilters.country !== item ?
                        (<li className="country-filter-block-item"> 
                            <button 
                                onClick={() => setCountry(item || '')}
                                className="country-filter-block-item__name"
                            >
                                <img
                                    src={ArrowDownYel}
                                    alt="arrow-down"
                                />
                                <div className="country-filter-block-item__text-wrp">
                                    {item}
                                    {
                                        !locationFilters.country ? (
                                            <span className="country-filter-block-item__counter">
                                                {countryCount}
                                            </span>
                                        ) : null
                                    }
                                </div>
                            </button>
                        </li>) : null
                    )
                })}
            </ul>
        </div>
    );
};